import { EuiTitle } from '@equipmentshare/ds2'
import { PageTitleProps } from './types'

export default function PageTitleEui( { title }: PageTitleProps ) {
	return <EuiTitle><h1>{title}</h1></EuiTitle>
}
